import { LoadingButton } from "@mui/lab";
import { Grid, Typography } from "@mui/material";
import {
  InputPassword,
  InputText,
  setTitleCase,
} from "app/components/template/partials";
import useAuth from "app/hooks/useAuth";
import { RegexUsername } from "configs/regex";
import { Field, Formik } from "formik";
import { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";

const initialValues = (autocomplete) => {
  return {
    username: autocomplete?.username ?? "",
    password: "",
  };
};

const initData = {
  username: "",
  password: "",
};

const validationSchema = Yup.object().shape({
  username: Yup.string()
    .required("Nama Pengguna wajib diisi!")
    .matches(RegexUsername, "Format Nama Pengguna tidak sesuai"),
  password: Yup.string().required("Kata Sandi wajib diisi!"),
});

export function HomePageSignIn() {
  const navigate = useNavigate();
  const [isLoading, setLoading] = useState(false);
  const { signIn } = useAuth();

  const handleFormSubmit = async (values) => {
    setLoading(true);
    try {
      const response = await signIn(values);
      navigate("/dashboard");
      toast.success(
        setTitleCase(`selamat datang, ${response.data?.nama_lengkap}!`)
      );
    } catch (error) {
      toast.error(setTitleCase(error.response.data?.message));
    }
    setLoading(false);
  };

  return (
    <div className="home-page-sign-in">
      <div className="home-page-sign-in-content">
        <Typography
          variant="h5"
          component="h5"
          className="home-page-sign-in-content-title"
        >
          Hai Warga Ngawi
        </Typography>
        <Typography
          variant="h6"
          component="h6"
          className="home-page-sign-in-content-subtitle"
        >
          Selamat Datang
        </Typography>
        <div className="home-page-sign-in-content-form">
          <Formik
            enableReinitialize
            onSubmit={handleFormSubmit}
            initialValues={initialValues(initData)}
            validationSchema={validationSchema}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Field
                  component={InputText}
                  name="username"
                  label="Nama Pengguna"
                  size="small"
                  variant="outlined"
                  type="text"
                  fullWidth
                  className="home-page-sign-in-content-form-input"
                  sx={{
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "white", // Warna border default
                    },
                    "& .MuiInputLabel-root": {
                      color: "white", // Warna label default
                    },
                    "& .MuiInputBase-input": {
                      color: "white", // Warna teks input default
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: "white", // Warna border saat dihover
                    },
                    "&:hover .MuiInputLabel-root": {
                      color: "white", // Warna label saat dihover
                    },
                    "&:hover .MuiInputBase-input": {
                      color: "white", // Warna teks input saat dihover
                    },
                    "&:focus .MuiOutlinedInput-notchedOutline": {
                      borderColor: "white", // Warna border saat diklik
                    },
                    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                      {
                        borderColor: "white", // Warna border saat input dalam keadaan fokus
                      },
                    "& .MuiInputLabel-root.Mui-focused": {
                      color: "white", // Warna label saat input dalam keadaan fokus
                    },
                    "& .MuiInputBase-input.Mui-focused": {
                      color: "white", // Warna teks input saat input dalam keadaan fokus
                    },
                    my: 1,
                  }}
                />
                <Field
                  component={InputPassword}
                  name="password"
                  key="password"
                  label="Kata Sandi"
                  size="small"
                  variant="outlined"
                  fullWidth
                  className="home-page-sign-in-content-form-input"
                  colorIconButton="white"
                  sx={{
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "white", // Warna border default
                    },
                    "& .MuiInputLabel-root": {
                      color: "white", // Warna label default
                    },
                    "& .MuiInputBase-input": {
                      color: "white", // Warna teks input default
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: "white", // Warna border saat dihover
                    },
                    "&:hover .MuiInputLabel-root": {
                      color: "white", // Warna label saat dihover
                    },
                    "&:hover .MuiInputBase-input": {
                      color: "white", // Warna teks input saat dihover
                    },
                    "&:focus .MuiOutlinedInput-notchedOutline": {
                      borderColor: "white", // Warna border saat diklik
                    },
                    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                      {
                        borderColor: "white", // Warna border saat input dalam keadaan fokus
                      },
                    "& .MuiInputLabel-root.Mui-focused": {
                      color: "white", // Warna label saat input dalam keadaan fokus
                    },
                    "& .MuiInputBase-input.Mui-focused": {
                      color: "white", // Warna teks input saat input dalam keadaan fokus
                    },
                    my: 1,
                  }}
                />
                <div className="home-page-sign-in-content-form-forget-password">
                  <NavLink
                    className="home-page-sign-in-content-form-forget-password-text"
                    to="/auth/sign-up"
                  >
                    Lupa kata sandi ?
                  </NavLink>
                </div>
                <div className="home-page-sign-in-content-form-button">
                  <Grid container spacing={2}>
                    <Grid item xs={6} lg={12}>
                      <LoadingButton
                        type="submit"
                        color="primary"
                        loading={isLoading}
                        variant="contained"
                        sx={{ borderRadius: 10 }}
                        fullWidth
                      >
                        Masuk
                      </LoadingButton>
                    </Grid>
                    <Grid item xs={6} lg={12}>
                      <Grid item xs={6} lg={12}>
                        <NavLink
                          to="/auth/sign-up"
                          style={{ textDecoration: "none" }}
                        >
                          <LoadingButton
                            type="submit"
                            color="primary"
                            loading={isLoading}
                            variant="contained"
                            sx={{ borderRadius: 10 }}
                            fullWidth
                          >
                            Halaman Daftar
                          </LoadingButton>
                        </NavLink>
                      </Grid>
                    </Grid>
                  </Grid>
                </div>
              </form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
}
